import { useTranslations } from "../../hooks/useTranslations";
import DepartmentApps from "../DepartmentApps";
import Page from "../ui/Page";
import PageSection from "../ui/PageSection";

const JoinHospitality = () => {
  const { i18n } = useTranslations();
  return (
    <Page
      title={i18n.departments.joinHospitality.title}
      description={i18n.departments.joinHospitality.description}
    >
      <PageSection title={i18n.nav.apps}>
        <DepartmentApps department="joinHospitality" />
      </PageSection>
    </Page>
  );
};

export default JoinHospitality;
